export default __webpack_public_path__ + "static/media/53.9dcd73a9.png";